import React from 'react';
import CreateForm from './CreateForm';
import { useAuthorizationChecker } from 'authorization-scope';
import { Button, ButtonColor, ButtonSize, IconType } from 'ui-builder';
import { TeamPermission } from 'nekst-api';
import { usePopupFormManager } from 'features/nekst-widgets';
import { useSetupAreaRequiredButtonsHelper } from '../../settings/markets/setupAreaRequiredHelper';

export default function CreatePlanButton() {
  const popupManager = usePopupFormManager();

  const { isGranted } = useAuthorizationChecker();

  const openCreatePlanForm = async () => {
    popupManager.openForm(
      <CreateForm />,
      true,
    );
  };

  const { isDisabled: isButtonDisabled, title: buttonTitle } = useSetupAreaRequiredButtonsHelper();

  if (isGranted(TeamPermission.CREATE_PLAN)) {
    return (
      <Button
        text="Create new workflow"
        onClick={openCreatePlanForm}
        size={ButtonSize.BIG}
        isFilled
        color={ButtonColor.BLUE}
        iconType={IconType.PLUS}
        isDisabled={isButtonDisabled}
        title={buttonTitle}
      />
    );
  } else {
    return null;
  }
}
